<template>
    <div class="box no-effect">
        <div class="box-header"
             v-if="custom_text">
            <small class="text-muted">
                {{ custom_text }}
            </small>
        </div>
        <div class="box-body">
            <div class="pl-2 pr-2 clear">
                <div class="pull-left">
                    <button class="btn btn-sm btn-icon btn-circle"
                            :class="!show_settings ? 'dark-greenish' : 'blackish'"
                            @click="toggleSettings">
                        <transition name="el-fade-in-linear">
                            <i class="material-icons"
                               v-show="!show_settings">settings</i>
                        </transition>
                        <transition name="el-fade-in-linear">
                            <i class="material-icons"
                               v-show="show_settings">close</i>
                        </transition>
                    </button>
                </div>
                <transition name="el-fade-in-linear">
                    <div class="pull-left ml-2"
                         v-show="show_settings">
                        <el-select v-model="event_name"
                                   placeholder="Select Event Name"
                                   size="mini"
                                   @change="changeGraph">
                            <el-option
                                    v-for="(item, index) in event_names"
                                    :key="index"
                                    :label="item | ucwords"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </transition>
                <transition name="el-fade-in-linear">
                    <div class="pull-left ml-2"
                         v-show="show_settings">
                        <el-select v-model="event_type"
                                   placeholder="Select Event Type"
                                   size="mini"
                                   @change="changeGraph">
                            <el-option
                                    v-for="(item, index) in event_types"
                                    :key="index"
                                    :label="item | ucwords"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </transition>
                <transition name="el-fade-in-linear">
                    <div class="pull-left ml-2"
                         v-show="show_settings">
                        <el-select v-model="event_interval"
                                   placeholder="Select Event Interval"
                                   size="mini"
                                   @change="changeGraph">
                            <el-option
                                    v-for="(item, index) in event_intervals"
                                    :key="index"
                                    :label="item | ucwords"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </transition>
            </div>
            <highcharts v-show="is_done"
                        class="admin-chart"
                        ref="highcharts"
                        :options="options"
                        :style="getStyle">
            </highcharts>
            <div class="el-table__empty-block"
                 v-show="!is_done && loading">
                <span class="el-table__empty-text"
                      style="color: #606266;">
                    Loading
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'

    export default {
        props: {
            company_id: {
                required: false
            },
            custom_text: {
                required: false
            },
            name: {
                required: false
            },
            type: {
                required: false
            },
            interval: {
                required: false
            }
        },

        data() {
            return {
                auth: auth,
                loading: false,
                is_done: false,
                CancelToken: null,
                source: null,
                show_settings: false,
                event_name: null,
                event_type: null,
                event_interval: null,
                event_names: [
                    'completed',
                    'abandoned',
                    'missed',
                    'failed',
                ],
                event_types: [
                    'inbound call',
                    'outbound call',
                    'inbound sms',
                    'outbound sms',
                ],
                event_intervals: [
                    '1 hour',
                    '3 hours',
                    '12 hours',
                    '1 day',
                    '3 days',
                    '1 week',
                    '1 month'
                ],
                chart_type: 'spline',
                options: {
                    chart: {
                        zoomType: 'x',
                        resetZoomButton: {
                            position: {
                                x: 0,
                                y: -40
                            }
                        }
                    },

                    title: {
                        text: ''
                    },

                    subtitle: {
                        text: document.ontouchstart === undefined ?
                            'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
                    },

                    rangeSelector: {
                        enabled: false
                    },

                    plotOptions: {
                        line: {
                            dataLabels: {
                                style: {
                                    fontSize: '14px'
                                }
                            }
                        },
                        spline: {
                            lineWidth: 1,
                            states: {
                                hover: {
                                    lineWidth: 2
                                }
                            },
                            marker: {
                                enabled: true,
                                radius: 3
                            },
                        },
                        areaspline: {
                            fillOpacity: 0.5,
                            marker: {
                                enabled: true,
                                radius: 3
                            }
                        },
                        column: {
                            stacking: 'normal',
                            dataLabels: {
                                style: {
                                    fontSize: '14px'
                                }
                            }
                        },
                        scatter: {
                            marker: {
                                radius: 5,
                                states: {
                                    hover: {
                                        enabled: true,
                                        lineColor: 'rgb(100,100,100)'
                                    }
                                }
                            },
                            states: {
                                hover: {
                                    marker: {
                                        enabled: false
                                    }
                                }
                            }
                        },
                        series: {
                            pointWidth: 5,

                            stacking: 'normal',

                            events: {
                                legendItemClick: function (e) {
                                    // Upon cmd-click of a legend item, rather than toggling visibility, we want to hide all other items.
                                    let hideAllOthers = e.browserEvent.metaKey
                                    if (hideAllOthers) {
                                        if (!this.visible) {
                                            return true
                                        }

                                        let seriesIndex = this.index
                                        let series = this.chart.series

                                        for (let i = 0; i < series.length; i++) {
                                            // rather than calling 'show()' and 'hide()' on the series', we use setVisible and then
                                            // call chart.redraw --- this is significantly faster since it involves fewer chart redraws
                                            if (series[i].index !== seriesIndex) {
                                                if (series[i].visible) {
                                                    series[i].setVisible(false, false)
                                                } else {
                                                    series[i].setVisible(true, false)
                                                }
                                            }
                                        }
                                        this.chart.redraw()
                                        return false
                                    }
                                }
                            }
                        }
                    },

                    time: {
                        useUTC: false,
                        timezone: window.timezone
                    },

                    // force the plot to show all ticks daily
                    xAxis: {
                        type: 'datetime',
                        crosshair: true,
                        dateTimeLabelFormats: {
                            millisecond: '%H:%M', // always use day as highest resolution.
                            second: '%H:%M', // always use day as highest resolution.
                            minute: '%H:%M', // always use day as highest resolution.
                            hour: '%H:%M',
                            day: '%e %b', // always use day as highest resolution.
                            week: '%e %b', // always use day as highest resolution.
                            month: '%b \'%y',
                            year: '%Y'
                        },
                        labels: {
                            rotation: 45,
                            style: {
                                fontSize: '14px'
                            },
                            overflow: "allow"
                        },
                        min: null,
                        max: moment.tz(window.timezone).second() || moment.tz(window.timezone).millisecond() ? moment.tz(window.timezone).add(1, 'minute').startOf('minute').valueOf() : moment.tz(window.timezone).startOf('minute').valueOf(),
                        tickInterval: null
                    },

                    yAxis: {
                        offset: -10,
                        title: {
                            text: 'Number Of Events',
                            margin: 10,
                            style: {
                                'font-size': '14px',
                                'color': '#090A0D'
                            }
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                'font-size': '14px'
                            }
                        },
                        labels: {
                            style: {
                                fontSize: '14px'
                            }
                        },
                        min: 0,
                        softMax: 50,
                        tickInterval: 1,
                        minTickInterval: 1
                    },

                    tooltip: {
                        useHTML: true,
                        shared: true,
                        style: {
                            color: '#2e3e4e',
                            fontSize: '14px'
                        },
                        formatter: function () {
                            let s = []
                            s.push(`<strong class="mb-0">Number Of Events</strong>`)
                            for (let point of this.points.filter((a) => a.y !== 0).sort((a, b) => b.y - a.y)) {
                                s.push(`<i class="fa fa-circle" style="color: ${point.series.color};"></i><span class="text-grey-900" style="font-size: 0.875rem"> ${point.series.name}: <b>${point.y.toLocaleString()}</b></span>`)
                            }
                            s.push(`<span class="text-grey-900 mt-0 mb-3" style="font-size: 0.75rem">Time: <b>${moment(this.x).format('hh:mm:ss').toString()}</b></span>`)
                            s = s.join("</br>")
                            return s
                        }
                    },

                    legend: {
                        layout: "horizontal",
                        enabled: true,
                        verticalAlign: "bottom",
                        floating: false,
                        maxHeight: 100
                    },

                    credits: {
                        enabled: false
                    },

                    exporting: {
                        enabled: false,
                        sourceWidth: 0,
                        sourceHeight: 0
                    },

                    series: []
                },
                aggregated_counts: [],
                default_chart_height: 400,
                chart_height: 400
            }
        },

        computed: {
            getStyle() {
                return {
                    height: this.chart_height + 'px'
                }
            },

            isLargeEnough() {
                let valid_sizes = ['xxl', 'xl', 'lg', 'md']
                if (valid_sizes.includes(this.$mq)) {
                    return true
                }
                return false
            },

            pluralForm() {
                if (this.event_type) {
                    return this.event_type.includes('call') ? 's' : ''
                }

                return ''
            },

            shouldIncreaaseChartHeight() {
                return this.options.series?.length > 12
            }
        },

        created() {
            this.CancelToken = axios.CancelToken
            this.source = this.CancelToken.source()
            // init graph from params
            if (this.name) {
                this.event_name = this.name
            }
            if (this.type) {
                this.event_type = this.type
            }
            if (this.interval) {
                this.event_interval = this.interval
            }
            this.changeGraph()
        },

        methods: {
            toggleSettings() {
                this.show_settings = !this.show_settings
            },

            changeGraph() {
                // fix graph min and tick interval
                if (this.event_name && this.event_type) {
                    let min, tick_interval
                    switch (this.event_interval) {
                        case '1 hour':
                            min = moment.tz(window.timezone).subtract(1, 'hours').valueOf()
                            tick_interval = 5 * 60 * 1000 // 5 minutes
                            break
                        case '3 hours':
                            min = moment.tz(window.timezone).subtract(3, 'hours').valueOf()
                            tick_interval = 10 * 60 * 1000 // 15 minutes
                            break
                        case '12 hours':
                            min = moment.tz(window.timezone).subtract(12, 'hours').valueOf()
                            tick_interval = 30 * 60 * 1000 // 30 minutes
                            break
                        case '1 day':
                            min = moment.tz(window.timezone).subtract(1, 'days').valueOf()
                            tick_interval = 60 * 60 * 1000 // 1 hour
                            break
                        case '3 days':
                            min = moment.tz(window.timezone).subtract(3, 'days').valueOf()
                            tick_interval = 3 * 60 * 60 * 1000 // 3 hours
                            break
                        case '1 week':
                            min = moment.tz(window.timezone).subtract(1, 'weeks').valueOf()
                            tick_interval = 8 * 60 * 60 * 1000 // 8 hours
                            break
                        case '1 month':
                            min = moment.tz(window.timezone).subtract(1, 'months').valueOf()
                            tick_interval = 24 * 60 * 60 * 1000 // 24 hours
                            break
                    }
                    this.options.xAxis.max = moment.tz(window.timezone).second() || moment.tz(window.timezone).millisecond() ? moment.tz(window.timezone).add(1, 'minute').startOf('minute').valueOf() : moment.tz(window.timezone).startOf('minute').valueOf()
                    this.options.xAxis.min = min
                    this.options.xAxis.tickInterval = tick_interval

                    // clear graph refresh interval
                    if (this.$options.monitor_graph_interval) {
                        clearInterval(this.$options.monitor_graph_interval)
                    }

                    // fix graph header
                    this.options.title.text = this.event_name.capitalize() + ' ' + this.$options.filters.capitalize_all(this.event_type) + this.pluralForm
                    // update graph
                    this.monitorReports()
                    // ping every 5 minutes
                    this.$options.monitor_graph_interval = setInterval(this.changeGraph, 1000 * 60 * 5)
                }
            },

            changeChartType(chart_type) {
                this.chart_type = chart_type

                let new_series = []
                for (let series of this.options.series) {
                    series.type = this.chart_type
                    new_series.push(series)
                }
                this.options.series = new_series
            },

            updateChartHeight() {
                this.chart_height = this.default_chart_height
                this.options.chart.height = this.chart_height
            },

            monitorReports() {
                this.source.cancel('monitorReports canceled by the user.')
                this.source = this.CancelToken.source()
                this.is_done = false
                this.loading = true
                this.options.series = []
                this.aggregated_counts = []
                return axios.get('/api/admin/monitor/reports', {
                    params: {
                        timezone: window.timezone,
                        event_name: this.event_name,
                        event_type: this.event_type,
                        interval: this.event_interval,
                        company_id: this.company_id
                    },
                    cancelToken: this.source.token
                }).then(res => {
                    // lets do some re-assignments
                    this.aggregated_counts = res.data
                    // if its not json it will crash the server.
                    if (!Array.isArray(this.aggregated_counts)) {
                        console.log("Non json response provided")
                        // stop execution
                        return Promise.reject("Non json response provided")
                    }

                    // loop over what you got and setup the plots.
                    for (let company_data of this.aggregated_counts) {
                        let series = {
                            type: this.chart_type,
                            name: company_data.name + ' (#' + company_data.id + ')',
                            data: Object.values(company_data.data),
                            showInLegend: (Object.keys(company_data.data).length > 0) ? true : false
                        }

                        this.options.series.push(series)
                    }

                    if (this.shouldIncreaaseChartHeight) {
                        this.updateChartHeight()
                    }

                    this.loading = false
                    this.is_done = true
                    this.$nextTick(() => {
                        if (this.$refs.highcharts) {
                            let highcharts_container = this.$refs.highcharts.$el

                            if (highcharts_container) {
                                this.options.exporting.sourceWidth = highcharts_container.clientWidth
                                this.options.exporting.sourceHeight = highcharts_container.clientHeight
                            }
                        }
                    })

                    return Promise.resolve(res)
                }).catch(err => {
                    if (axios.isCancel(err)) {

                        // return Promise.reject(err)
                    } else {
                        this.loading = false

                        return Promise.reject(err)
                    }
                })
            }
        },

        watch: {
            name: function () {
                if (this.name) {
                    this.event_name = this.name
                    this.changeGraph()
                }
            },

            type: function () {
                if (this.type) {
                    this.event_type = this.type
                    this.changeGraph()
                }
            },

            interval: function () {
                if (this.interval) {
                    this.event_interval = this.interval
                    this.changeGraph()
                }
            },
        },

        beforeDestroy() {
            clearInterval(this.$options.monitor_graph_interval)
        }
    }
</script>
